/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'environments/environment';
import { HttpHelpersService } from 'app/shared/services/http-helpers.service';

@Injectable({
  providedIn: 'root',
})
export class ClubsService {
  constructor(private httpClient: HttpClient) {}

  getClubById(clubId: number) {
    return HttpHelpersService.handleGetResponse(this.httpClient.get(`${environment.apiHostname}/v1/clubs/${clubId}`));
  }
}
